import { Images } from "../../images";

type Props = {
	imageSrc: keyof typeof Images;
	altText: string;
	className?: string;
	aria?: string;
};

const Image = ({ imageSrc, altText, className, aria = altText }: Props) => (
	<img className={className} src={Images[imageSrc]} aria-label={aria} alt={altText} />
);

export default Image;
